import {Component, Input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {EmMarkdownPipe} from '@emma-labs/shared/angular';
import {QuestionId, TranslatedUiQuestion, WeightUnit} from '@emma-labs/shared/typescript';
import {NgxMaskDirective} from 'ngx-mask';
import {CardModule} from 'primeng/card';
import {DropdownModule} from 'primeng/dropdown';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {SelectButtonModule} from 'primeng/selectbutton';

@Component({
  selector: 'em-question',
  templateUrl: './question.component.html',
  imports: [
    InputNumberModule,
    SelectButtonModule,
    ReactiveFormsModule,
    DropdownModule,
    NgxMaskDirective,
    InputTextModule,
    InputTextareaModule,
    CardModule,
    EmMarkdownPipe,
  ],
})
export class QuestionComponent {
  readonly QUESTION_ID = QuestionId;
  readonly WEIGHT_UNIT_OPTIONS = [
    {value: WeightUnit.POUNDS, text: 'lbs'},
    {value: WeightUnit.KILOGRAMS, text: 'kg'},
  ];

  @Input({required: true}) question!: TranslatedUiQuestion;
  @Input({required: true}) control!: FormControl;
  @Input() extraControl: FormControl | undefined;
  @Input() bmi: number | undefined;
}
